import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { DataPackValue } from '../../../../../app/models/dataPackValue.model';
import { AlertService } from '../../../../../app/utils/alert.service';
import { ConsumeService } from '../../../../../app/services/consume.service';
import { VoiceConsumeService } from '../../../../../app/services/voice.consume.service';

import * as _ from "lodash";
import { BindComponentService } from '../../../../utils/bind.component.service';

/**
 * @version $Id$
 */
@Component({
  selector: 'editBatchQuota',
  templateUrl: './content.modal.template.html'
  
})
@Injectable()
export class EditBatchQuotaComponent {

  @Input() selectedGroup: DataPackGroup;
  @Input() hasHibridService: boolean;
  @Input() hasOverBalanceMonetaryVoice: boolean;

  public saving: boolean = false;
  public limit: DataPackValue =  new DataPackValue();
  public overBalance: DataPackValue = new DataPackValue();
  public overBalanceNextCycle: DataPackValue = new DataPackValue();
  public limitPerLine: string;
  public overBalancePerLine: string;
  public overBalanceNextCyclePerLine: string;
  public limitPattern: string = '\\d+$';
  public overBalanceLimitPattern = new RegExp('^($|0)|(:?(?=[^0])(\\d{1,3},?){1,3}|0)(\\.\\d{1,2})?$');
  public isIlimitedGroup: boolean = false;
  public isChangingLimit: boolean;
  public isChangingOverBalance: boolean;
  public isChangingOverBalanceNextCycle: boolean;
  
  
   

  constructor(private activeModal: NgbActiveModal,
    private voiceConsumeService: VoiceConsumeService,
    private consumeService: ConsumeService,
    private alertService: AlertService,
    private bindComponent: BindComponentService) {

  }




  ngOnInit() {
    //console.log("TESTE")
    this.limit.value = null;
    this.checkIlimitedGroup();
    this.limitPerLine = this.preventNullDatapackValuePerLine(this.selectedGroup.limit);
    this.overBalancePerLine = this.preventNullDatapackValuePerLine(this.getOverBalancedLimit()).toString().split(",")[0];
    this.overBalanceNextCyclePerLine = this.preventNullDatapackValuePerLine(this.getOverBalanceNextCycle()).toString().split(",")[0];
    this.saving = true;
  }

  private getOverBalancedLimit() : DataPackValue {
    //console.log ('this.selectedGroup.overBalanceLimit');
    //console.log(this.selectedGroup.overBalanceLimit);
    return ( (!this.hasOverBalanceMonetaryVoice && !this.hasHibridService) ? this.selectedGroup.overBalanceAllCallsLimit : this.selectedGroup.overBalanceLimit);
  }

  private getOverBalanceNextCycle() : DataPackValue {
    
    return ( !this.hasOverBalanceMonetaryVoice ? this.selectedGroup.overBalanceAllCallsLimitNextCycleControll : this.selectedGroup.overBalanceLimitNextCycleControll);
  }

  private checkIlimitedGroup() {
    this.isIlimitedGroup = ( ((null == this.selectedGroup.limit) || ( null == this.selectedGroup.limit.value)) );
  }

  /*
  private commaToDot(event: any) {
    if (event.target.value && event.target.value.indexOf(',')) {
      event.target.value = event.target.value.replace(',', '.');
    }
  }

  private preventNullLimit(group: DataPackGroup) {
    if (_.isNil(group.availableLimit)) {
      group.availableLimit = new DataPackValue();
      group.availableLimit.value = '0';
      group.availableLimit.dataPackValueType = 'MIN';
    }
  }

  private preventNullDataPackValue(dataPackValue: DataPackValue): DataPackValue {
    if (_.isNil(dataPackValue)) {
      dataPackValue = new DataPackValue();
      dataPackValue.value = '0';
    }
    return dataPackValue;
  }*/

  private preventNullDatapackValuePerLine(dataPackValue: DataPackValue): string {
    if ( (null != dataPackValue) && ( null != dataPackValue.value) ) {
      return dataPackValue.value;
    } 
    return "---";
  }

  private preventNullOverBalance(group: DataPackGroup) {
    if (_.isNil(group.availableOverBalance)) {
      group.availableOverBalance = new DataPackValue();
      group.availableOverBalance.value = '0';
      group.availableOverBalance.dataPackValueType = 'R$';
    }
  }

  private save() {
    this.saving = false;
    if (this.limit.value && this.limit.value.indexOf(',')) {
      this.limit.value = this.limit.value.replace(',', '.');
    }
    let group: DataPackGroup = new DataPackGroup;
    group = this.selectedGroup;
    group.limit = this.limit;
    group.overBalanceLimit = this.overBalance;
    group.overBalanceAllCallsLimit = this.overBalance;
    group.overBalanceLimitNextCycleControll = this.overBalanceNextCycle;
    group.overBalanceAllCallsLimitNextCycleControll = this.overBalanceNextCycle;
    //console.log('save');
    let payload = {
      action: 'ConfigureLimitAndExceedInBatch',
      hasHibridService: this.hasHibridService,
      sourceGroup: group,
      isChangingLimit : this.isChangingLimit,
      isChangingOverBalance : this.isChangingOverBalance,
      isChangingOverBalanceNextCycle : this.isChangingOverBalanceNextCycle
    };
    this.voiceConsumeService.configureLimitAndExceedInBatch(payload).subscribe(
      data => {
        this.alertService.success(data['result']);
        this.saving = false;
        this.activeModal.close();
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION, true);
      },
      err => {
        this.alertService.error(err.result, err);
        this.saving = false;
        this.activeModal.close();
      }
    );
  }

  private isLineLimitValueValid(value: string) {
    let patt = new RegExp(this.limitPattern);
    return patt.test(value);
  }

  private isLineOverBalenceValid(value: string) {
    let patt = new RegExp(this.overBalanceLimitPattern);
    return patt.test(value);
  }

  private updateLimit(event: any) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.limit.value) {
        let eventValue = event.target.value;
        if (eventValue.indexOf(',')) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        if ((parseFloat(eventValue) > parseFloat(this.selectedGroup.limit.value))) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos limites atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    } else {
      this.saving = false;
    }
  }

  private updateOverBalance(event: any,isMinute:boolean) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.overBalance.value) {
        let eventValue = event.target.value;
        if (eventValue.indexOf(',')&& isMinute ) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        if ( parseFloat(eventValue) > parseFloat(this.overBalancePerLine) ) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos excedentes atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    } else {
      this.saving = false;
    }
  }

  
 
  private updateOverBalanceNextCycle(event: any) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.overBalanceNextCycle.value) {
        let eventValue = event.target.value;
        if (eventValue.indexOf(',')) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        if ( parseFloat(eventValue) > parseFloat(this.overBalanceNextCyclePerLine) ) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos excedentes outras atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    } else {
      this.saving = false;
    }
  }

  public SwitchTypeValue(text: string, valueType: boolean) {
    //valor em minutos  : valor em reais
    return (valueType)? 'R$ '.concat(text) : text.concat(' MIN');
  }

  private close() {
    this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/batch/content.component.ts